"use strict";
import { List, Map, Record, Iterable } from "immutable";
import Cache from "./cache";
const buildGetFactory = (cacheConfiguration) => {
  const config = Map(cacheConfiguration).delete("apiEndpoint");
  return (cache) => config.entrySeq().map(
    ([key, value]) => List.of(
      buildGetter(key, value),
      buildAfterGetter(key, value)
    )
  ).flatten(true).map(
    ([key, value]) => [key, _.partial(value, cache)]
  ).fromEntrySeq().toMap().toJS();
};
const buildAfterGetter = (key, configuration) => {
  if (configuration.type === "Collection") {
    return [key + "After", (cache, timestamp) => Cache.getItem(cache, [key], timestamp)];
  } else if (configuration.type === "Entity") {
    return [key + "After", (cache, id, timestamp) => Cache.getItem(cache, [configuration.table, id], timestamp)];
  } else if (configuration.type === "Related") {
    return [key + "After", (cache, id, timestamp) => Cache.getItem(cache, [key, id], timestamp)];
  } else if (configuration.type === "RangedCollection") {
    return [key + "After", (cache, id, range, timestamp) => Cache.getRangedCollection(cache, [key, id], range, timestamp)];
  }
};
const buildGetter = (key, configuration) => {
  if (configuration.type === "Collection") {
    return [key, (cache, id) => Cache.getItem(cache, [key])];
  } else if (configuration.type === "Entity") {
    return [key, (cache, id) => Cache.getItem(cache, [configuration.table, id])];
  } else if (configuration.type === "Related") {
    return [key, (cache, id) => Cache.getItem(cache, [key, id])];
  } else if (configuration.type === "RangedCollection") {
    return [key, (cache, id, range) => Cache.getRangedCollection(cache, [key, id], range)];
  }
};
const buildInitialCache = (cacheConfiguration) => {
  const config = Map(cacheConfiguration).delete("apiEndpoint");
  const initialValues = Map(Iterable(config.entries()).map(([key, value]) => {
    return initialValue(key, value);
  }));
  return Record({
    data: Map(initialValues.filter((pair) => pair !== null)),
    lastRequestId: 0,
    requests: Map()
  })();
};
const initialValue = (key, configuration) => {
  if (configuration.type === "Collection") {
    return null;
  } else if (configuration.type === "Entity") {
    return [configuration.table, Map()];
  } else if (configuration.type === "Related") {
    return [key, Map()];
  } else if (configuration.type === "RangedCollection") {
    return [key, Map()];
  }
};
const buildFetchNeedsConfiguration = (cacheConfiguration) => {
  const apiEndpoint = cacheConfiguration.apiEndpoint;
  const config = Map(cacheConfiguration).delete("apiEndpoint");
  const collections = List(config.filter((value) => {
    return value.type === "Collection";
  }).keys());
  const rangedCollections = List(config.filter((value) => {
    return value.type === "RangedCollection";
  }).keys());
  const requestGroups = config.mapEntries(([key, value]) => {
    if (value.table) {
      return [value.table, value.requestGroup];
    } else {
      return [key, value.requestGroup];
    }
  });
  return Map({
    apiEndpoint,
    collections,
    rangedCollections,
    requestGroups
  });
};
export default {
  build(cacheConfiguration) {
    return {
      getFactory: buildGetFactory(cacheConfiguration),
      initialCache: buildInitialCache(cacheConfiguration),
      fetchNeedsConfiguration: buildFetchNeedsConfiguration(cacheConfiguration)
    };
  }
};
